import { createContext, useContext } from 'react';

/**
 * AI-capability seam.
 *
 * Carries ONLY whether AI features are enabled for the current user. AIChatProvider provides it
 * as its outermost layer, but the seam itself is a platform concern — the chatbot is one surface
 * of the platform's AI, so non-chatbot feature gates (global header, lite views, assessment page)
 * read this hook and never a chatbot context.
 *
 * Lives outside core/chatbot on purpose: jest maps every core/chatbot/* import to one shared
 * Proxy mock, so a seam hosted there could not be mocked (or left real) independently of the
 * chatbot in consumer tests.
 *
 * The default value makes useIsAIEnabled() return false when no provider is mounted, so
 * consumers can call it unconditionally. It never throws.
 */
type AICapabilityValue = { isAIEnabled: boolean };

export const AICapabilityContext = createContext<AICapabilityValue>({ isAIEnabled: false });

export function useIsAIEnabled(): boolean {
  return useContext(AICapabilityContext).isAIEnabled;
}
